/**
 *  @class
 *  @function BackgroundVideo
 */
if (!customElements.get('background-video')) {
	class BackgroundVideo extends HTMLElement {
		connectedCallback() {
			this.videoContainer = this.querySelector('.background-video__iframe');
			if (!this.videoContainer) return;

			this._observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						this.loadVideo();
						this._observer.disconnect();
					}
				});
			}, { rootMargin: '100px' });

			this._observer.observe(this);
		}

		disconnectedCallback() {
			if (this._observer) {
				this._observer.disconnect();
			}
		}

		loadVideo() {
			let tpl = this.videoContainer.querySelector('template.background-video__deferred');
			if (tpl) {
				tpl.replaceWith(tpl.content.cloneNode(true));
			}

			let iframe = this.videoContainer.querySelector('iframe');
			let video = this.videoContainer.querySelector('video');

			if (iframe) {
				iframe.onload = () => this.playIframe();
			} else if (video) {
				video.play();
			}
		}

		playIframe() {
			let iframe = this.videoContainer.querySelector('iframe');
			if (!iframe) return;

			if (this.videoContainer.dataset.provider === 'youtube') {
				iframe.contentWindow.postMessage(JSON.stringify({ event: "command", func: "playVideo", args: "" }), "*");
			} else if (this.videoContainer.dataset.provider === 'vimeo') {
				iframe.contentWindow.postMessage(JSON.stringify({ method: "play" }), "*");
			}
		}
	}
	customElements.define('background-video', BackgroundVideo);
}
